import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React__default from 'react';

const useStyles = makeStyles(
  (theme) => ({
    alpha: {
      color: theme.palette.common.white,
      fontFamily: "serif",
      fontWeight: "normal",
      fontStyle: "italic"
    },
    beta: {
      color: "#4d65cc",
      fontFamily: "serif",
      fontWeight: "normal",
      fontStyle: "italic"
    }
  }),
  { name: "BackstageLifecycle" }
);
function Lifecycle(props) {
  const classes = useStyles(props);
  const { shorthand, alpha } = props;
  return shorthand ? /* @__PURE__ */ React__default.createElement(
    Typography,
    {
      component: "span",
      className: classes[alpha ? "alpha" : "beta"],
      style: { fontSize: "120%" }
    },
    alpha ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, "\u03B1") : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, "\u03B2")
  ) : /* @__PURE__ */ React__default.createElement(Typography, { component: "span", className: classes[alpha ? "alpha" : "beta"] }, alpha ? "Alpha" : "Beta");
}

export { Lifecycle };
//# sourceMappingURL=Lifecycle.esm.js.map
